import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL, BASE_URL } from '../common/Constants';
import Cookies from '../common/Cookies';

const ResellerContext = createContext();

const DEFAULT_FAVICON = (process.env.PUBLIC_URL || '') + '/favicon.ico';

/** Sync read so login/invite first paint can use cached reseller (avoids default-logo flash). */
function readCachedReseller() {
  const cached = Cookies.getCookies('reseller');
  if (!cached) return null;
  try {
    const data = JSON.parse(cached);
    return data && typeof data === 'object' ? data : null;
  } catch {
    return null;
  }
}

function getFaviconHref(reseller) {
  if (!reseller?.faviconPath?.trim()) return DEFAULT_FAVICON;
  const path = reseller.faviconPath.trim();
  if (path.startsWith('http://') || path.startsWith('https://')) return path;
  return `${BASE_URL}/api/public/reseller/${reseller.id}/favicon`;
}

export function ResellerProvider({ children }) {
  const [reseller, setReseller] = useState(() => readCachedReseller());
  const [resellerResolved, setResellerResolved] = useState(() => readCachedReseller() != null);

  useEffect(() => {
    const link = document.querySelector('link[rel="icon"]');
    if (link) {
      link.href = getFaviconHref(reseller);
    }
    const productName = reseller?.productName || 'Chattitude';
    document.title = `Powered With ${productName}`;
  }, [reseller]);

  useEffect(() => {
    const baseUrl = window.location.origin || window.location.hostname;
    const cached = Cookies.getCookies('reseller');
    if (cached) {
      try {
        const resellerData = JSON.parse(cached);
        setReseller(resellerData);
        setResellerResolved(true);
        return;
      } catch {
        /* invalid cache, fall through to fetch */
      }
    }
    axios
      .get(`${API_URL}/public/reseller`, { params: { baseUrl } })
      .then((res) => {
        if (res.data) {
          console.log('reseller', res.data);
          Cookies.setCookies('reseller', JSON.stringify(res.data));
          setReseller(res.data);
        }
      })
      .catch(() => { /* no reseller for this URL */ })
      .finally(() => {
        setResellerResolved(true);
      });
  }, []);

  return (
    <ResellerContext.Provider value={{ reseller, setReseller, resellerResolved }}>
      {children}
    </ResellerContext.Provider>
  );
}

export function useReseller() {
  return useContext(ResellerContext);
}
